export default function PageLoader() {
  return (
    <div
      className="page-loader"
      style={{
        minHeight: '40vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#64748B',
      }}
      role="status"
      aria-label="Loading page"
    >
      Loading…
    </div>
  );
}
